import $ from 'jquery';

export default class Mobile {
  constructor() {
    this.menuCaller = $('.mobile_caller');
    this.searchCaller = $('.mobile_search_caller');
    this.window = $(window);
    this.body = $('body');
    this.mobileMenuOpenedClass = 'mobile-menu-opened';
    this.mobileSearchOpenedClass = 'mobile-search-opened';
    this.openClass = 'open';
  }

  menuAction() {
    this.body.on('click', 'a.mobile_caller', (event) => {
      event.preventDefault();
      this.body.toggleClass(this.mobileMenuOpenedClass);
      this.menuCaller.toggleClass(this.openClass);
    });

    this.body.on('click', 'a.mobile_search_caller', (event) => {
      event.preventDefault();
      this.body.toggleClass(this.mobileSearchOpenedClass);
      this.searchCaller.toggleClass(this.openClass);
    });

    this.window.on('resize', () => {
      if (this.window.width() > 768) {
        this.closeMobileMenu();
        this.closeMobileSearch();
      }
    });
  }

  buildMobile(json) {
    $.each(json, (i, structure) => {
      $.each(structure[0].before_content, (i, element) => {
        $(element)
          .addClass('hide_if_mobile')
          .clone()
          .removeClass('hide_if_mobile')
          .addClass('cloned')
          .appendTo(structure[0].place);
      });

      $.each(structure[0].content, (i, element) => {
        const clone = $(element).clone();
        $(element).addClass('hide_if_mobile');

        clone
          .find('li>ul')
          .parent()
          .addClass('has-submenu')
          .find('>a')
          .append('<span class="mobile-toggle"><i class="fa fa-angle-down"></i></span>');

        clone.find('.has-submenu>ul>li>a').prepend('<span class="pre">-</span>');
        clone.removeClass('hide_if_mobile').addClass('cloned').appendTo(structure[0].place);
      });

      $.each(structure[0].after_content, (i, element) => {
        $(element)
          .addClass('hide_if_mobile')
          .clone()
          .removeClass('hide_if_mobile')
          .addClass('cloned')
          .appendTo(structure[0].place);
      });
    });
  }

  toggleMenu() {
    $('.mobile-navigation-place li.has-submenu>a>.mobile-toggle').on('click', function (event) {
      event.preventDefault();
      $(this).parents('li').toggleClass('open');
    });
  }

  closeMobileMenu() {
    this.body.removeClass(this.mobileMenuOpenedClass);
    this.menuCaller.removeClass(this.openClass);
  }

  closeMobileSearch() {
    this.body.removeClass(this.mobileSearchOpenedClass);
    this.searchCaller.removeClass(this.openClass);
  }

  init() {
    const mobileData = {
      mob_nav: [
        {
          place: '.mobile-navigation-place',
          class: 'mob_nav_header',
          before_content: ['.usable_logo'],
          after_content: [''],
          content: ['.b-menus', '.a-menus', '.menu'],
        },
      ],
    };

    this.buildMobile(mobileData);
    this.menuAction();
    this.toggleMenu();
  }
}
